<template>
  <div>
    <v-dialog v-model="show" width="350" persistent>
      <v-card>
        <div class="header-icon-wrapper">
          <v-icon color="blue darken-2">mdi-account-multiple</v-icon>
        </div>
        <div class="wrapper-title">
          <h3>{{ $t('chooseProcess') }}</h3>
        </div>
        <div class="wrapper-text">
          <v-card-text></v-card-text>
        </div>
        <div class="d-flex justify-center">
          <v-progress-circular
          v-if="isLoading"
          size="32"
          indeterminate
          color="primary"
        ></v-progress-circular>
        </div>
        <v-radio-group
          class="process-selection-group"
          v-model="stateValues.checked"
        >
          <v-radio
            v-for="process in processList"
            :key="process.code"
            :label="process.description"
            :value="process.code"
          ></v-radio>
        </v-radio-group>

        <v-divider class="main-action-process-list-divider"></v-divider>
        <div class="process-main-actions">
          <v-btn large outlined color="primary" @click="onClickCancel" :disabled="isLoading"
            >{{ $t('cancel')}}</v-btn
          >
          <v-btn large color="primary" @click="onClickSendLink" :disabled="isLoading || stateValues.checked.length === 0"
            >{{ $t('sendLink') }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ChooseProcessDialog from "./mixin/ChooseProcessDialog";

export default {
  mixins: [ChooseProcessDialog],
};
</script>
<style lang="scss" scoped>
$primaryColor: #3fa2f7;

.header-icon-wrapper {
  text-align: center;
  padding-top: 20px;
  .v-icon {
    font-size: 3rem;
    padding: 25px;
    border-radius: 50%;
    border: 4px solid #3fa2f7;
  }
}
.wrapper-title {
  text-align: center;
  margin-top: 5%;
  color: $primaryColor;
}
.wrapper-text {
  text-align: center;
  color: $primaryColor;
}
.process-selection-group {
  padding-left: 15px;
}
.main-action-process-list-divider {
  margin-bottom: 5%;
}
.process-main-actions {
  text-align: center;
  padding-bottom: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/ChooseProcessDialog.vue